import {useAxiosClient} from "~/use/axios/client";
import {keepPreviousData, useQueryClient} from "@tanstack/vue-query";
import {
    ActionModelsLibrarySBLNoteSblAppListNoteSblAppNoteSblAppItem,
    NotesAndFilesApi
} from "~/gen/openapi/sblService";
import {MS_HOUR, MS_MINUTE} from "~/constants/time";
import {useOnline} from "@vueuse/core";

export const useNotesService = () => {
    const { axiosClient } = useAxiosClient()
    const notesApi = new NotesAndFilesApi(undefined, '', axiosClient.value)
    const isOnline = useOnline()
    const queryClient = useQueryClient()

    const getNotesAndFilesQueryOptions = {
        queryKey: ['notesAndFilesGetNotes'],
        queryFn: async () => {
            try {
                return (await notesApi.notesAndFilesGetNotes())?.data?.ListNoteSblApps || []
            } catch (error) {
                console.error(error)
                return Promise.reject(error)
            }
        },
        staleTime: 15 * MS_MINUTE,
        refetchOnWindowFocus: false,
        placeholderData: keepPreviousData,
        networkMode: 'offlineFirst',
        gcTime: MS_HOUR,
        enable: isOnline
    }

    const addOrUpdateNoteInCache = (newNote: ActionModelsLibrarySBLNoteSblAppListNoteSblAppNoteSblAppItem) => {
        queryClient.setQueryData(['notesAndFilesGetNotes'], (oldData: Array<ActionModelsLibrarySBLNoteSblAppListNoteSblAppNoteSblAppItem>) => {
            const existingNoteIndex = oldData.findIndex((existingNote: any) => existingNote.NoteSblAppId === newNote.NoteSblAppId)
            const newData = [...oldData]
            if (existingNoteIndex > -1) {
                newData.splice(existingNoteIndex, 1, newNote)
            } else {
                newData.push(newNote)
            }
            return newData
        })
    }

    const removeNoteFromCache = (noteId: string) => {
        queryClient.setQueryData(['notesAndFilesGetNotes'], (oldData: Array<ActionModelsLibrarySBLNoteSblAppListNoteSblAppNoteSblAppItem>) => {
            const existingNoteIndex = oldData.findIndex((existingNote: any) => existingNote.NoteSblAppId === noteId)
            const newData = [...oldData]
            if (existingNoteIndex > -1) {
                newData.splice(existingNoteIndex, 1)
            }
            return newData
        })
    }

    return {
        getNotesAndFilesQueryOptions,
        addOrUpdateNoteInCache,
        removeNoteFromCache,
    }
}